import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';

export interface CompanyConfigureParams { }

export type CompanyConfigureResponse = {
	companyCreated: boolean,
	userAttachedToCompany: boolean
}

export class CompanyConfigureCommand extends Command<CompanyConfigureParams, CompanyConfigureResponse> { }

export class CompanyConfigureCommandHandlerBase implements CommandHandler<CompanyConfigureCommand, CompanyConfigureParams, CompanyConfigureResponse> {
	private static Url = TaggedUrl.join('myCompany/initialize', [Tags.Api]);

	public constructor(
		private readonly http: HttpService
	) { }

	public async handleAsync(_: CompanyConfigureCommand): Promise<CompanyConfigureResponse> {
		const { data } = await this.http.get<CompanyConfigureResponse>(CompanyConfigureCommandHandlerBase.Url, { timeout: 1.5 * MS_PER_MINUTE });
		return data;
	}
}
